export default "__VITE_ASSET__d5c6e49b__"